import { render, staticRenderFns } from "./SwitchAcessarField.vue?vue&type=template&id=6f229a8e&scoped=true&"
import script from "./SwitchAcessarField.vue?vue&type=script&lang=js&"
export * from "./SwitchAcessarField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAcessarField.vue?vue&type=style&index=0&id=6f229a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f229a8e",
  null
  
)

export default component.exports